/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import Card from "components/generals/Card";
import { Formik, FormikConfig } from "formik";

/**
 * Props for FormikForm component.
 * Generic wrapper around Formik configuration with card styling options.
 * 
 * @interface FormikFormPros
 * @template T - Type of form values object
 * @extends {FormikConfig<T>}
 * @property {string} [cardClassName] - CSS class name for the card wrapper
 * @property {React.CSSProperties} [cardStyle] - Inline styles for the card
 */
export interface FormikFormPros<T> extends FormikConfig<T> {
  cardClassName?: string;
  cardStyle?: React.CSSProperties;
}

/**
 * Formik form wrapper with Material-UI Card container.
 * Generic component providing consistent card-based form layout.
 * 
 * Features:
 * - Generic type support for type-safe form values
 * - Card wrapper with padding
 * - Custom styling via className and style props
 * - Full Formik configuration passthrough
 * - Render props pattern support
 * 
 * Layout:
 * - Default padding: 1rem
 * - Card container for visual consistency
 * - Customizable styles merged with defaults
 * 
 * Usage:
 * ```tsx
 * <FormikForm<MyFormValues>
 *   initialValues={initialValues}
 *   validationSchema={schema}
 *   onSubmit={handleSubmit}
 * >
 *   {(formikProps) => <Form>...</Form>}
 * </FormikForm>
 * ```
 * 
 * Note: TODO comment indicates planned refactoring of submit buttons
 * 
 * @template T - Form values object type
 * @param props - FormikConfig props plus card styling options
 * @returns Formik form wrapped in Material-UI Card
 */
const FormikForm = <T extends Object>(props: FormikFormPros<T>) => {
  return (
    <Card style={{ padding: "1rem", ...props.cardStyle }} className={props.cardClassName}>
      <Formik {...props}>
        {props.children}
        {/*TODO: Refactor the submit buttons. 
        (formikState: FormikState<T>) => (
          <Form id="patientData" autoComplete="off">
            <Box mt={2} width="100%" display="flex" justifyContent="end">
              {props.children(formikState) as ReactNode}
              <Grid item xs={1}>
                <Button variant="contained" color="secondary">
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button type="submit" variant="contained" color="info" disabled={formikState.isSubmitting}>
                  Save
                </Button>
              </Grid>
            </Box>
          </Form>
        )*/}
      </Formik>
    </Card>
  );
};

export default FormikForm;
